import { FC, useState } from "react";
import { Button, Grid, Loader, Select } from "@mantine/core";
import { Page } from "../../../Components/Page";
import { RegieGameDetails } from "./Components/RegieGameDetails";
import { useShowCommentatorNotification } from "../../../hooks/useCommentatorNotification";
import {
  IconHeadset,
  IconHeadsetOff,
  IconQuestionMark,
} from "@tabler/icons-react";
import { CompetitionCommand, sendCommand } from "../../../commandTypes.ts";
import { useCommand } from "../../../hooks/useCommand.ts";
import { useCompetitionList } from "../../../hooks/useCompetitionList.ts";
import { getPresentationParamsForOrigin } from "../../../getPresentationParamsForOrigin.ts";
import { useUpcomingGames } from "../../../hooks/useUpcomingGames.ts";

export const Regie: FC = () => {
  const [competitionId, setCompetitionId] = useState<string>(
    getPresentationParamsForOrigin().competitionId,
  );
  useCommand<CompetitionCommand>("competition", (c) => {
    setCompetitionId(c.competitionId);
  });

  const competitionData = useCompetitionList();
  const showCommentatorNotification = useShowCommentatorNotification();

  const upcomingGameData = useUpcomingGames(competitionId, true);

  if (!competitionData.isSuccess) {
    return <Loader />;
  }

  return (
    <Page title="Regie">
      <Select
        my="md"
        label="Turnier"
        value={competitionId}
        onChange={(v) => {
          if (!v) {
            return;
          }
          setCompetitionId(v);
        }}
        data={competitionData.data.competitions.map((c) => ({
          value: c.id,
          label: c.name,
        }))}
      />

      <Button
        size="xl"
        onClick={() =>
          showCommentatorNotification
            ? void sendCommand({ command: "commentator.off" })
            : void sendCommand({ command: "commentator.on" })
        }
        color={
          showCommentatorNotification
            ? "red"
            : showCommentatorNotification == undefined
              ? "yellow"
              : "green"
        }
        leftSection={
          showCommentatorNotification ? (
            <IconHeadsetOff />
          ) : showCommentatorNotification == undefined ? (
            <IconQuestionMark />
          ) : (
            <IconHeadset />
          )
        }
      >
        Kommentator:{" "}
        {showCommentatorNotification
          ? "Meldung entfernen"
          : showCommentatorNotification == undefined
            ? "Status unbekannt"
            : "Meldung anzeigen"}
      </Button>

      {upcomingGameData && (
        <Grid mt="lg">
          {upcomingGameData.slice(0, 3).map((g) => (
            <Grid.Col key={g.id} span={{ xs: 6 }}>
              <RegieGameDetails gameId={g.id} />
            </Grid.Col>
          ))}
        </Grid>
      )}
    </Page>
  );
};
